export const ERROR_CODES = {
  TOKEN_EXPIRED: 7,
} as const;
